export const editApplicationModal = (props) =>
  import('./EditApplicationModal' /* webpackChunkName: "topology-modals" */).then((m) =>
    m.editApplicationModal(props),
  );
